import { useSettingsStore } from '../stores/settingsStore';
import { useMemo } from 'react';

export const useSettings = () => {
  const settings = useSettingsStore();

  // Computed values based on settings - simplified to avoid performance issues
  const computed = useMemo(() => ({
    // Icon visibility helpers
    shouldShowIcons: settings.iconStyle !== 'none',
    shouldShowCategoryIcons: settings.iconStyle !== 'none' && settings.showCategoryIcons,
    shouldShowStatusIcons: settings.iconStyle !== 'none' && settings.showStatusIcons,
    shouldShowNavigationIcons: settings.iconStyle !== 'none' && settings.showNavigationIcons,
    
    // Display helpers
    shouldShowImages: settings.showImages,
    shouldShowThumbnails: settings.showThumbnails,
    shouldShowBackgroundElements: settings.showBackgroundElements,
    shouldShowAnimations: settings.showAnimations && !settings.reducedMotion,
    
    // Theme helpers
    isCompact: settings.compactMode,
    isHighContrast: settings.highContrast,
    hasReducedMotion: settings.reducedMotion,
    
    // AI features
    shouldShowAISummaries: settings.enableAISummaries,
    shouldUseSmartGrouping: settings.enableSmartGrouping,
    shouldShowAutocomplete: settings.enableAutocomplete,
    shouldShowSuggestions: settings.enableSuggestions,
    
    // Performance helpers
    shouldPreloadData: settings.preloadData,
    shouldUseVirtualScrolling: settings.virtualScrolling,
    batchSize: settings.batchSize,
    cacheEnabled: settings.cacheEnabled,
  }), [
    settings.iconStyle,
    settings.showCategoryIcons,
    settings.showStatusIcons,
    settings.showNavigationIcons,
    settings.showImages,
    settings.showThumbnails,
    settings.showBackgroundElements,
    settings.showAnimations,
    settings.reducedMotion,
    settings.compactMode,
    settings.highContrast,
    settings.enableAISummaries,
    settings.enableSmartGrouping,
    settings.enableAutocomplete,
    settings.enableSuggestions,
    settings.preloadData,
    settings.virtualScrolling,
    settings.batchSize,
    settings.cacheEnabled,
  ]);

  return {
    ...settings,
    ...computed,
  };
};

export default useSettings; 